export const materialAccountTableOption = {
  align: "center",
  menuAlign: "center",
  headerAlign: "center",
  border: true,
  expand: false,
  stripe: false,
  showHeader: true,
  index: true,
  indexLabel: "序号",
  selection: true,
  menu: true,
  page: true,
  addBtn: false,
  editBtn: false,
  menuType: "text",
  delBtn: false,
  viewBtn: false,
  defaultSort: {
    prop: "createTime",
    order: "descending",
  },
  column: [
    {
      label: "ID",
      prop: "id",
      type: "input",
      hide: true,
    },
    {
      label: "用户ID",
      prop: "userId",
      type: "input",
      hide: true,
    },
    // rootDepartId
    {
      label: "顶级部门ID",
      prop: "rootDepartId",
      type: "input",
      hide: true,
    },
    {
      label: "用户姓名",
      prop: "userName",
      placeholder: "请输入用户姓名",
      search: true,
      type: "input",
    },
    {
      label: "用户账号",
      prop: "userMobile",
      placeholder: "请输入用户账号",
      search: true,
      type: "input",
    },

    {
      label: "余额",
      prop: "balance",
      type: "input",
      formatter: (row) => {
        return row.balance ? row.balance.toFixed(2) : "0.00";
      },
    },
  ],
};

// 材料账户明细表格配置
export const materialAccountDetailTableOption = {
  align: "center",
  menuAlign: "center",
  headerAlign: "center",
  border: true,
  expand: false,
  stripe: false,
  showHeader: true,
  index: true,
  indexLabel: "序号",
  selection: true,
  menu: false,
  page: true,
  addBtn: false,
  editBtn: false,
  menuType: "text",
  delBtn: false,
  viewBtn: false,
  defaultSort: {
    prop: "createTime",
    order: "descending",
  },
  column: [
    {
      label: "ID",
      prop: "id",
      type: "input",
      hide: true,
    },
    {
      label: "用户姓名",
      prop: "userName",
      placeholder: "请输入用户姓名",
      type: "input",
    },
    {
      label: "用户账号",
      prop: "userMobile",
      placeholder: "请输入用户账号",
      type: "input",
    },

    {
      label: "变动金额",
      prop: "amount",
      type: "input",
      formatter: (row) => {
        return row.amount ? row.amount.toFixed(2) : "0.00";
      },
    },

    {
      label: "余额",
      prop: "balance",
      type: "input",
      formatter: (row) => {
        return row.balance ? row.balance.toFixed(2) : "0.00";
      },
    },
    {
      label: "备注",
      prop: "remarks",
      type: "input",
    },
    {
      label: "创建时间",
      prop: "createTime",
      type: "datetime",
      format: "yyyy-MM-dd HH:mm:ss",
      search: false,
    },

    /* {
      label: "账户类型",
      prop: "type",
      type: "select",
      search: true,
      dicData: [
        { label: '净水', value: 'PURE_WATER' },
        { label: '防水', value: 'WATERPROOF' },
        { label: '吊顶', value: 'HANG_CEILING' },
      ],
      formatter: (row) => {
        const typeMap = {
          'PURE_WATER': '净水',
          'WATERPROOF': '防水',
          'HANG_CEILING': '吊顶'
        };
        return typeMap[row.type] || row.type;
      }
    },{
      label: "操作类型",
      prop: "operationType",
      type: "select",
      search: true,
      dicData: [
        { label: '充值', value: 'RECHARGE' },
        { label: '消费', value: 'CONSUME' },
        { label: '退款', value: 'REFUND' },
      ],
      formatter: (row) => {
        const typeMap = {
          'RECHARGE': '充值',
          'CONSUME': '消费',
          'REFUND': '退款'
        };
        return typeMap[row.operationType] || row.operationType;
      }
    },
    {
      label: "变动金额",
      prop: "amount",
      type: "input",
      formatter: (row) => {
        return row.amount ? row.amount.toFixed(2) : '0.00';
      }
    },
    {
      label: "交易时间",
      prop: "transactionTime",
      type: "datetime",
      format: "yyyy-MM-dd HH:mm:ss",
      search: false
    },
    {
      label: "交易描述",
      prop: "description",
      type: "input",
      search: true
    },
    {
      label: "操作人",
      prop: "operatorName",
      type: "input",
      search: true
    }
      */
  ],
};
